module.exports = __webpack_public_path__ + "img/search-image.033ca007.jpg";